
import SettingGeneral from './General/Index'
import EditSettingGeneral from './General/Edit'

import SettingSalePersonList from './SalePerson/List.vue'
import SettingSalePersonAdd from './SalePerson/Add.vue'
import SettingSalePersonEdit from './SalePerson/Edit.vue'

import SettingTermsOfPaymentList from './TermsOfPayment/List'
import SettingTermsOfPaymentAdd from './TermsOfPayment/Add'
import SettingTermsOfPaymentEdit from './TermsOfPayment/Edit'

import SettingMarketList from './Market/List.vue'
import SettingMarketAdd from './Market/Add.vue'
import SettingMarketEdit from './Market/Edit.vue'

import SettingAgentTypeList from './AgentType/List.vue'
import SettingAgentTypeAdd from './AgentType/Add.vue'
import SettingAgentTypeEdit from './AgentType/Edit.vue'

export default [
  {
    path: 'general',
    name: 'SettingGeneral',
    component: SettingGeneral
  },
  {
    path: 'general/edit',
    name: 'EditSettingGeneral',
    props: true,
    component: EditSettingGeneral
  },
  {
    path: 'sale-person',
    name: 'SettingSalePersonList',
    component: SettingSalePersonList
  },
  {
    path: 'sale-person/add',
    name: 'SettingSalePersonAdd',
    component: SettingSalePersonAdd
  },
  {
    path: 'sale-person/edit',
    name: 'SettingSalePersonEdit',
    props: true,
    component: SettingSalePersonEdit
  },
  {
    path: 'terms-of-payment',
    name: 'SettingTermsOfPaymentList',
    component: SettingTermsOfPaymentList
  },
  {
    path: 'terms-of-payment/add',
    name: 'SettingTermsOfPaymentAdd',
    component: SettingTermsOfPaymentAdd
  },
  {
    path: 'terms-of-payment/edit',
    name: 'SettingTermsOfPaymentEdit',
    props: true,
    component: SettingTermsOfPaymentEdit
  },
  {
    path: 'market',
    name: 'SettingMarketList',
    component: SettingMarketList
  },
  {
    path: 'market/add',
    name: 'SettingMarketAdd',
    component: SettingMarketAdd
  },
  {
    path: 'market/edit',
    name: 'SettingMarketEdit',
    props: true,
    component: SettingMarketEdit
  },
  {
    path: 'agent-type',
    name: 'SettingAgentTypeList',
    component: SettingAgentTypeList
  },
  {
    path: 'agent-type/add',
    name: 'SettingAgentTypeAdd',
    component: SettingAgentTypeAdd
  },
  {
    path: 'agent-type/edit',
    name: 'SettingAgentTypeEdit',
    props: true,
    component: SettingAgentTypeEdit
  }
]
